import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Constants.
 */

export enum HubspotFieldTypesEnum {
  // Valid values for type field
  BOOLEAN = 'boolean',
  ENUM = 'enumeration',
  STRING = 'string',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  DATETIME = 'dateTime',
  NUMBER = 'number',
  BOOL_CHECKBOX = 'booleancheckbox',
  CALULATION_EQUATION = 'calculation_equation',
  RADIO = 'radio',
  SELECT = 'select', // Dropdown
  TEXT = 'text', // Plain text, displayed in single line text input.
  TEXTAREA = 'textarea', // Plain text, displayed as multi-line text input
  REFERENCE_USER = 'referenceuser',
}

/*
 * Runtime type.
 */

const RCrmHubspotFieldDirty = t.readonly(
  t.type({
    id: t.string,
    label: t.string,
    type: makeEnumRuntimeType(HubspotFieldTypesEnum),
  }),
);

/*
 * Type.
 */

export interface CrmHubspotFieldModel extends t.TypeOf<typeof RCrmHubspotFieldDirty> {}
export const RCrmHubspotField = t.clean<CrmHubspotFieldModel>(RCrmHubspotFieldDirty as any);
export const RCrmHubspotFields = t.readonlyArray(RCrmHubspotField);

/*
 * IO methods.
 */

export function parseCrmHubspotField(src: any) {
  return {
    id: src.name,
    label: src.label,
    type: src.type,
  };
}

export function parseCrmHubspotFields(src: any): ReadonlyArray<CrmHubspotFieldModel> {
  return src.map(parseCrmHubspotField);
}

/*
 * API type.
 */

export const ApiCrmHubspotField = makeApiType('crmHubspotField', RCrmHubspotField, parseCrmHubspotField);
export const ApiCrmHubspotFields = makeApiType('crmHubspotFields', RCrmHubspotFields, parseCrmHubspotFields);
